import {createFileRoute} from '@tanstack/react-router';
import BookCourtView from '../../../marketplace/BookCourtView';

export const Route = createFileRoute('/_app/book-court/')({
    component: RouteComponent,
});

function RouteComponent() {
    return <BookCourtView />;
}
